import React, { useState, useRef, useImperativeHandle } from "react";
import { Popconfirm, Tooltip, theme } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleFilled,
} from "@ant-design/icons";
import TSTable from "../../../common/TSTable";
import ColorButton from "../../../common/ColorButton";
import { DELETE } from "../../../frameworks/HttpClient";
import { URL_TRUCK } from "../../../constants/urls";
import { dateToHumanString } from "../../../frameworks/Util";
import SellVehicleModal from "./SellVehicleModal";
import ErrorMessages from "../../../common/ErrorMessages";
import CustomDeleteConfirmButton from "../../../common/CustomDeleteConfirmButton";

const SellVehicleLatexList = React.forwardRef((props, ref) => {
  const { isDone } = props;
  const [target, setTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages , setErrorMessages] = useState(null);

  const {
    token: { colorWarning, colorError, colorSuccess },
  } = theme.useToken();

  useImperativeHandle(ref, () => ({
    fetchTable: refreshData,
  }));

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessages (error.errorMessages);
      }
    }
  };

  const handleEdit = (record) => {
    if (!record || !record.id) {
      return;
    }
    setTarget(record);
  };

  const handleDelete = async (id) => {
    if (!id) {
      return;
    }
    setErrorMessages(null);
    try {
      await DELETE(`${URL_TRUCK.VEHICLE}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages (error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) =>
        isDone ? null : (
          <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
            <Tooltip triger='hover' title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
                style={{ margin : 5}}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: "ทะเบียนรถ",
      dataIndex: "license_plate",
      key: "code",
      align: "center",
    },
    {
      title: "จังหวัด",
      dataIndex: "province_name",
      key: "province_name",
      searcher: true,
      align: "center",
    },
    {
      title: "ประเภทรถ",
      dataIndex: "type_name",
      key: "type",
      align: "center",
    },
    {
      title: "เจ้าของ",
      dataIndex: "supplier_name",
      key: "supplier_name",
      align: "center",
      searcher: true,
      render : (value) => value ? value : <center>-</center>
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      align: "center",
      render : (value) => dateToHumanString(value)
    },
    {
      title: "วันที่แก้ไขล่าสุด",
      dataIndex: "updated",
      key: "updated",
      align: "center",
      render : (value) => dateToHumanString(value)
    }
];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type="primary"
        override={colorSuccess}
        icon={<PlusCircleFilled />}
        style={{ marginBottom: 10, float: "right" }}
        onClick={() => setTarget('add')}
      >
        เพิ่มรถน้ำยางสด
      </ColorButton>
      <TSTable
        columns={columns}
        size="small"
        url={`${URL_TRUCK.VEHICLE}`}
        ref={tableRef}
      />
      <SellVehicleModal
        open={target ? true : false}
        onClose={() => {
          setTarget(null);
        }}
        onUpdate={() => {
          refreshData();
          setTarget(null);
        }}
        target={target}
      />
    </div>
  );
});

export default SellVehicleLatexList;
